import React, {useEffect, useMemo} from 'react';
import {VStack} from "native-base";
import {t} from "../../../../../services/i18n";
import {analyzeYupSchema, checkRequired} from "../../../../../services/stepperService";
import TextEditor from "../../../../common/TextEditor/TextEditor";
import FormInput from "../../../../common/FormInput";
import AppText from "../../../../common/AppText";
import CustomCheckbox from "../../../../common/CustomCheckbox";
import usePermissions from "../../../../../services/Permissions";
import orderBy from "lodash-es/orderBy";
import {familyArray} from "../../../../../services/ConstHelper";
import moment from "moment";
import {useSelector} from "react-redux";


//pop = 1 -> show in user profile and in appointment manage
//pop = 2 -> show only in user profile
//pop = 3 -> show only in appointment manage

const PROFILE_AND_MANAGE = 1;
const PROFILE = 2;
const MANAGE = 3;
const NOTHING = 0;

const GeneralNote = (props) => {
    const { errors, values, setFieldValue, touched, validationSchema, target, groupData } = props;
    const boxLocations = useSelector((state) => state.box?.box?.locations_box);
    const {has} = usePermissions()

    const timeFormat = useMemo(() => boxLocations ? boxLocations[0].time_format : null,[boxLocations])
    const dateFormat = useMemo(() => boxLocations ? boxLocations[0].date_format : null,[boxLocations])
    const validationObject = useMemo(() => analyzeYupSchema(validationSchema), [validationSchema]);
    const group = useMemo(() => {
        if(groupData?.length > 1) {
            let arr = []
            arr = orderBy(groupData, [
                'head',
                (item) => {
                    const index = familyArray.indexOf(item.user_box.child);
                    return index === -1 ? 1000 : index;
                },
                (item) => `${item.user_box.first_name ?? ''} ${item.user_box.last_name ?? ''}`],
                ['desc','asc', 'desc'])
            arr = arr.map(member => {
                let label = t(`family-checkbox-${member.head ? 'head' : member.user_box.child}`, {name: `${member.user_box.first_name ?? ''} ${member.user_box.last_name ?? ''}`})
                if(member.user_box.active === 0) {
                    label = `${label} (${t('inactive')})`
                }
                return {...member, user_fk: member.user_box.user_fk, label: label}
            })
            return arr
        }
        return null
    }, [groupData]);

    const handlePopSelection = (option, selected) => {
        let pop = 0
        switch (option) {
            case 'profile':
                if(selected) {
                    if(values.pop === NOTHING) {
                        pop = 2
                    } else if(values.pop === MANAGE) {
                        pop = 1
                    }
                } else {
                    if(values.pop === PROFILE_AND_MANAGE) {
                        pop = 3
                    } else if(values.pop === PROFILE) {
                        pop = 0
                    }
                }
                break;
            case 'manage':
                if(selected) {
                    if(values.pop === NOTHING) {
                        pop = 3
                    } else if(values.pop === PROFILE) {
                        pop = 1
                    }
                } else {
                    if(values.pop === PROFILE_AND_MANAGE) {
                        pop = 2
                    } else if(values.pop === PROFILE) {
                        pop = 0
                    }
                }
                break;
        }
        setFieldValue('pop', pop)
    }

    const handleGroupSelection = (member, selected) => {
        let groupSelection = values.group ? [...values.group] : []
        if(selected) {
            groupSelection.push(member.user_fk)
        } else {
            groupSelection = groupSelection.filter(m => m !== member.user_fk)
        }
        setFieldValue('group', groupSelection)
    }

    return (
        <VStack maxH={'550px'} overflowY={'auto'} space={'0.5rem'}>
            <FormInput label={`${t('note-input-label')}${checkRequired('text', validationObject)}`}
                       width={'100%'}
                       error={(touched.text && errors.text) ? errors.text : null}
                       helper={target ? t('general-note-last-edit', {dateTime: moment(target.updated_at).format(`${dateFormat}, ${timeFormat}`), staff: target.created_by.full_name}) : null}
                       containerProps={{ mb: target ? '1.5rem' : '1rem' }}
            >
                <div style={{height: '300px'}}>
                    <TextEditor placeholder={t('add-session-note-here-placeholder')}
                                onChange={(text) => setFieldValue('text', text)}
                                value={values.text}
                    />
                </div>
            </FormInput>
            {has('generalNotesPopAction') &&
            <FormInput label={`${t('pop-note-label')}${checkRequired('pop', validationObject)}`} infoTooltip={t('pop-note-tooltip')}>
                <VStack space={'0.2rem'}>
                    <CustomCheckbox text={t('pop-note-user-profile-checkbox')} isChecked={values.pop === 1 || values.pop === 2} onChange={(val) => handlePopSelection('profile', val)} />
                    {has('appointments') && <CustomCheckbox text={t('pop-note-appointment-manage-checkbox')} isChecked={values.pop === 1 || values.pop === 3} onChange={(val) => handlePopSelection('manage', val)} />}
                </VStack>
            </FormInput>
            }
            {group &&
                <FormInput label={t('family-note-label')} infoTooltip={t('family-note-tooltip')}>
                    <VStack space={'0.2rem'}>
                        {group.map(member => (
                            <CustomCheckbox text={member.label} isChecked={(values.group ?? []).includes(member.user_fk)} onChange={(val) => handleGroupSelection(member, val)} />
                        ))}
                    </VStack>
                </FormInput>
            }
        </VStack>
    );
};

export default GeneralNote;